import { lazy } from 'react';

const List = lazy(() => import('./list'));
const Create = lazy(() => import('./form/create'));
const Edit = lazy(() => import('./form/edit'));

export { List, Edit, Create };
